import {createFilter} from 'react-select';
import type {GroupBase, PropsValue, SingleValue} from 'react-select';
import {SelectOption} from '@chekin/core';
// eslint-disable-next-line import/no-unresolved
import {FilterOptionOption} from 'react-select/dist/declarations/src/filters';

const customFilter = <T, V, L>(
  option: FilterOptionOption<SelectOption<T, V, L>>,
  inputValue: string,
) => {
  const filter = createFilter<SelectOption<T, V, L>>({
    ignoreAccents: true,
    ignoreCase: true,
    matchFrom: 'any',
  });
  return filter(option, inputValue);
};

function isSingleValue<T>(value: PropsValue<T>): value is SingleValue<T> {
  return !Array.isArray(value);
}

function isGroup<T, V, L>(
  value: SelectOption<T, V, L> | GroupBase<SelectOption<T, V, L>>,
): value is GroupBase<SelectOption<T, V, L>> {
  return 'options' in value;
}

export {customFilter, isSingleValue, isGroup};
